import type { KpiDataRange } from 'components/molecules/PackArchitecture/kpiAxisConfiguration.utils';
import type { KpiAxisControlsMeta } from 'components/molecules/PackArchitecture/kpiAxisControlsMeta.types';
import { DEFAULT_KPI_DATA_RANGE } from 'constants/ppa';

import type { WhitespaceMetaResponse, WhitespaceOptionItem } from './whitespaceAnalysisContext.types';

export const DEFAULT_WHITESPACE_PAGE_LIMIT = 50;
/** Cross-section items shown per cell on first paint; also used as the initial grid child page size. */
export const WHITESPACE_INITIAL_CHILD_VISIBLE_COUNT = 4;

export type WhitespacePaginationLimits = {
    child: number;
    column: number;
    row: number;
};

export const getOptionLabel = (option: WhitespaceOptionItem) => option.label ?? option.id ?? '';

export const getDefaultOptionLabel = (options: WhitespaceOptionItem[]) =>
    getOptionLabel(options.find((option) => option.is_default) ?? options[0] ?? {});

export const getWhitespacePaginationLimits = (
    meta?: WhitespaceMetaResponse | null,
): WhitespacePaginationLimits => ({
    child: toNumeric(meta?.options?.child_limit ?? meta?.child_limit, DEFAULT_WHITESPACE_PAGE_LIMIT),
    column: toNumeric(meta?.options?.column_limit ?? meta?.column_limit, DEFAULT_WHITESPACE_PAGE_LIMIT),
    row: toNumeric(meta?.options?.row_limit ?? meta?.row_limit, DEFAULT_WHITESPACE_PAGE_LIMIT),
});

export const toNumeric = (value: unknown, fallback = 0): number => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : fallback;
    if (typeof value === 'string' && value.trim() !== '') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    }
    return fallback;
};

export const getYKpiDataRangeFromControlsMeta = (controlsMeta: KpiAxisControlsMeta | null): KpiDataRange => {
    if (!controlsMeta) return { ...DEFAULT_KPI_DATA_RANGE };
    return {
        defaultMin: controlsMeta.range.minInput.defaultValue,
        defaultMax: controlsMeta.range.maxInput.defaultValue,
    };
};
